import React, { useEffect, useState } from "react";
import axios from "axios";
import Style from "../Style/AdmintestimonialsView.module.scss";

const baseURL = process.env.REACT_APP_BASE_URL;

const AdmintestimonialsView = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    location: "",
    designation: "",
    feedback: "",
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  const fetchTestimonials = async () => {
    try {
      const res = await axios.get(`${baseURL}/get/testimonials`);
      console.log("API response:", res.data); // Ye add karo
      setTestimonials(res.data);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/testimonials/${id}`);
      setTestimonials(testimonials.filter((t) => t.id !== id));
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };
  const handleEditClick = (testimonial) => {
    setEditId(testimonial.id);
    setEditFormData({
      name: testimonial.name,
      location: testimonial.location || "",
      designation: testimonial.designation || "",
      feedback: testimonial.feedback,
    });
    setShowModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({ ...editFormData, [name]: value });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${baseURL}/api/testimonials/${editId}`, editFormData);
      setEditId(null);
      setShowModal(false);
      fetchTestimonials();
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  return (
    <div className={Style.testimonialsWrapper}>
      <h2>All Testimonials</h2>

      <div className={Style.tableResponsive}>
        <table className={Style.testimonialsTable}>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Location</th>
              <th>Feedback</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {testimonials.map((t, index) => (
              <tr key={t.id}>
                <td>{index + 1}</td>
                <td>{t.name}</td>
                <td>{t.designation}</td>
                <td>{t.location}</td>
                <td>{t.feedback}</td>
                <td>
                  <button onClick={() => handleEditClick(t)}>Edit</button>
                  <button onClick={() => handleDelete(t.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className={Style.modalOverlay}>
          <div className={Style.modalContent}>
            <h3>Edit Testimonial</h3>
            <input
              type="text"
              name="name"
              value={editFormData.name}
              onChange={handleEditChange}
              placeholder="Name"
            />
            <input
              type="text"
              name="designation"
              value={editFormData.designation}
              onChange={handleEditChange}
              placeholder="Designation"
            />
            <input
              type="text"
              name="location"
              value={editFormData.location}
              onChange={handleEditChange}
              placeholder="Location"
            />
            <textarea
              name="feedback"
              value={editFormData.feedback}
              onChange={handleEditChange}
              placeholder="Feedback"
            />
            <div className={Style.actions}>
              <button onClick={handleEditSubmit}>Update</button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdmintestimonialsView;
